import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const createAppTE = <E = CF.API.ApiError>(
  {
    userId,
    body,
  }: {
    userId?: string;
    params?: string;
    body: CF.API.Apps.CreateAppBody;
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Apps.createMockApp> =>
  fetchTE<CF.API.Apps.createMockApp, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps`,
      method: 'POST',
      body: {
        apps: [body],
      },
    },
    onRejected,
  );
